import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  Button,
  MenuItem,
} from "@mui/material";

function BankFormModal({
  open,
  isEditing,
  formData,
  onClose,
  onChange,
  onSubmit,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        {isEditing ? "Update Bank" : "Create Bank"}
      </DialogTitle>

      <form onSubmit={onSubmit}>
        <DialogContent>
          <Grid container spacing={2}>
            {/* Name EN */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Name (EN)"
                name="name_en"
                value={formData.name_en}
                onChange={onChange}
                required
              />
            </Grid>

            {/* Name FR */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Name (FR)"
                name="name_fr"
                value={formData.name_fr}
                onChange={onChange}
              />
            </Grid>

            {/* Description EN */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Description (EN)"
                name="description_en"
                value={formData.description_en}
                onChange={onChange}
                multiline
                rows={2}
              />
            </Grid>

            {/* Description FR */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Description (FR)"
                name="description_fr"
                value={formData.description_fr}
                onChange={onChange}
                multiline
                rows={2}
              />
            </Grid>

            {/* Branch Code */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Branch Code"
                name="branch_code"
                value={formData.branch_code}
                onChange={onChange}
                required
              />
            </Grid>

            {/* Status */}
            {/* <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                select
                label="Status"
                name="status"
                value={formData.status}
                onChange={onChange}
                size="medium"
                sx={{
                  '& .MuiSelect-select': {
                    padding: '10.5px 14px', // same as default input padding
                  },
                  '& .MuiInputBase-root': {
                    fontSize: 16,       // adjust text size
                    height: 40,
                  },

                }}
                required
              >
                <MenuItem value="active">Active</MenuItem>
                <MenuItem value="inactive">Inactive</MenuItem>
              </TextField>
            </Grid> */}

            {/* Address */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Address"
                name="address"
                value={formData.address}
                onChange={onChange}
                multiline
                rows={3}
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="submit" variant="contained" color="primary" style={{
            whiteSpace: "nowrap",
            color: "white",
          }}>
            {isEditing ? "Update" : "Create"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default BankFormModal;
